import { ImageLoaderConfig } from '@angular/common';
import { isDevMode } from '@angular/core';

/**
 * Vercel Image Optimisation loader for Angular NgOptimizedImage.
 *
 * - SVGs bypass the optimiser (regex matches `.svg` with optional query string).
 * - In dev mode, returns the raw source URL unchanged so `ng serve` never
 *   tries to hit `/_vercel/image`.
 * - In prod, rewrites to `/_vercel/image?url=...&w=...&q=75` with the
 *   requested width snapped to the nearest allowed Vercel width.
 */
export const VERCEL_WIDTHS = [64, 96, 128, 256, 384, 640, 750, 828, 1080, 1200, 1920, 2048, 3840] as const;
export const DEFAULT_QUALITY = 75;

export function imageQualityForSource(src: string): number {
  return /\/(?:sam4_hardware_motor_control_cabinet_c0fee4c60b\.jpg|YW_site_visit_image_01_1_f30ef326f0\.jpg|Nyrstar_website_case_study_thumbnail_42a64d5885\.jpg|Schipol_1_34f7bd211d\.webp)(?:\?|$)/.test(src) ? 65 : DEFAULT_QUALITY;
}

function nearestAllowedWidth(width: number): number {
  for (const allowed of VERCEL_WIDTHS) {
    if (allowed >= width) return allowed;
  }
  return VERCEL_WIDTHS[VERCEL_WIDTHS.length - 1];
}

export function vercelImageLoader(config: ImageLoaderConfig): string {
  if (/\.svg(\?|$)/i.test(config.src)) {
    return config.src;
  }
  if (isDevMode()) {
    return config.src;
  }
  const w = nearestAllowedWidth(config.width ?? 1200);
  return `/_vercel/image?url=${encodeURIComponent(config.src)}&w=${w}&q=${imageQualityForSource(config.src)}`;
}
